import React from 'react';
import {
  IRetentionCohortFieldsFragment,
  RetentionCohortOperatorKey,
} from '../../../../utils/apollo/graphqlSchema';
import InfoPopupHeaderSetting from '../InfoPopupHeaderSetting';
import * as BuilderInfoUI from '../../BuilderInfoUI';
import { CohortConditionIcon } from '../../../Icon';
import CohortDetailsDateRange from './CohortDetailsDateRange';
import {
  generateCustomRetentionTimeBracketText,
  parseRetentionUnit,
  RETENTION_CUSTOM_BRACKET_OPERATOR_TYPES,
} from '../../../Builder/Cohorts/CohortRow/utils';
import CohortDetailsDurationStartDate from './CohortDetailsDurationStartDate';
import { isNil } from 'lodash';
import {
  CohortDetailsBorderedInfo,
  CohortDetailsContent,
} from './CohortDetailsUI';

interface IProps {
  cohort: IRetentionCohortFieldsFragment;
  cohortIndex: number;
}

export default ({ cohort, cohortIndex }: IProps) => {
  const {
    type,
    operator,
    timeWindow,
    timeWindowValues,
    retentionOperatorValues,
    analysis,
    returnedOperator,
    datePicker,
    subject,
    durationStartDate,
    lookForwardWindow,
  } = cohort;
  const { retentionUnit, customTimeBrackets } = analysis.query;
  const isCustomTimeBracketsOnTimeWindow = customTimeBrackets?.length > 0;
  const isCustomTimeBracketsOnOperatorValues =
    RETENTION_CUSTOM_BRACKET_OPERATOR_TYPES.includes(operator.retentionKey) &&
    customTimeBrackets?.length > 0;

  return (
    <>
      <BuilderInfoUI.HeaderContainer>
        <CohortConditionIcon conditionIndex={cohortIndex} />
        <InfoPopupHeaderSetting label={'Subject'}>
          {subject.name}
        </InfoPopupHeaderSetting>
        <InfoPopupHeaderSetting label={'Type'}>
          {type.name}
        </InfoPopupHeaderSetting>
        <CohortDetailsDateRange datePicker={datePicker} />
        {durationStartDate && (
          <CohortDetailsDurationStartDate
            durationStartDate={durationStartDate}
          />
        )}
      </BuilderInfoUI.HeaderContainer>
      <CohortDetailsContent>
        <BuilderInfoUI.HighlightedLabel>
          Retention
        </BuilderInfoUI.HighlightedLabel>
        <CohortDetailsBorderedInfo>
          <BuilderInfoUI.StyledPopupLabel>
            {analysis.display}
          </BuilderInfoUI.StyledPopupLabel>
        </CohortDetailsBorderedInfo>
        <CohortDetailsBorderedInfo>{operator.name}</CohortDetailsBorderedInfo>
        {returnedOperator && (
          <CohortDetailsBorderedInfo>
            {returnedOperator.name}
          </CohortDetailsBorderedInfo>
        )}
        {isCustomTimeBracketsOnOperatorValues &&
        retentionOperatorValues?.length > 0 ? (
          <CohortDetailsBorderedInfo>
            {generateCustomRetentionTimeBracketText(
              retentionOperatorValues[0],
              customTimeBrackets,
              retentionUnit,
            )}
          </CohortDetailsBorderedInfo>
        ) : (
          retentionOperatorValues?.length > 0 && (
            <>
              <CohortDetailsBorderedInfo>
                {retentionOperatorValues[0]}
              </CohortDetailsBorderedInfo>
              {retentionOperatorValues.length === 2 && (
                <>
                  <div>and</div>
                  <CohortDetailsBorderedInfo>
                    {retentionOperatorValues[1]}
                  </CohortDetailsBorderedInfo>
                </>
              )}
              {operator?.retentionKey ===
                RetentionCohortOperatorKey.Returned && <div>times</div>}
            </>
          )
        )}
        {!isNil(lookForwardWindow) && (
          <>
            <div>through {parseRetentionUnit(retentionUnit)}</div>
            <CohortDetailsBorderedInfo>
              {lookForwardWindow}
            </CohortDetailsBorderedInfo>
          </>
        )}

        <CohortDetailsBorderedInfo>{timeWindow.name}</CohortDetailsBorderedInfo>
        {timeWindowValues?.length > 0 && (
          <>
            <CohortDetailsBorderedInfo>
              {isCustomTimeBracketsOnTimeWindow
                ? generateCustomRetentionTimeBracketText(
                    timeWindowValues[0],
                    customTimeBrackets,
                    retentionUnit,
                  )
                : timeWindowValues[0]}
            </CohortDetailsBorderedInfo>
            {timeWindowValues.length === 2 && (
              <>
                <div>and</div>
                <CohortDetailsBorderedInfo>
                  {isCustomTimeBracketsOnTimeWindow
                    ? generateCustomRetentionTimeBracketText(
                        timeWindowValues[1],
                        customTimeBrackets,
                        retentionUnit,
                      )
                    : timeWindowValues[1]}
                </CohortDetailsBorderedInfo>
              </>
            )}
            {!isCustomTimeBracketsOnTimeWindow && (
              <div>{parseRetentionUnit(retentionUnit)}</div>
            )}
          </>
        )}
      </CohortDetailsContent>
    </>
  );
};
